import { css } from '@emotion/css';

export const iconButton = css`
  border-radius: 0.4rem;
  width: 2.8rem;
  height: 2.8rem;
  margin: 0.2rem;
  padding: 0.4rem;
`;
